
  <!-- /.box-body -->
  <!-- Loading (remove the following to stop the loading)-->
  <div style="z-index: 99999 !important;" class="modal-backdrop modal-backdrop-white fade show" *ngIf="value.show" [ngStyle]="{'display':value.show ? 'block' : 'none'}"></div>

  <div class="loading">
    <div class="" *ngIf="value.show">
      <!--<i class="fa fa-refresh fa-spin"></i>-->
      <div class="loadingDiv"></div>
    </div>
  </div>
